import React               from 'react';
import { SortableElement } from 'react-sortable-hoc';

function KirokuSortableElement(props) {
    return <div {...props}/>;
}
export default SortableElement(KirokuSortableElement);
